import axios from '@/axios';

const RESOURCE_NAME = '/needs';

export default {
    createNeed(need) {
        return axios.post(`${RESOURCE_NAME}/create-need`, {need});
    },

    getIndexList() {
        return axios.get(`${RESOURCE_NAME}/get-index-list`)
    },

    getTodos() {
        return axios.get(`${RESOURCE_NAME}/get-todos`);
    },

    getOnboardingStep() {
        return axios.get(`${RESOURCE_NAME}/get-onboarding-step`)
    },

    saveOnboardingStep(step) {
        return axios.post(`${RESOURCE_NAME}/save-onboarding-step`, {step})
    },
}
